/**
 * Page limit used when loading SMS templates into a picker that filters
 * client-side (applicant texting menu, bulk SMS drawer).
 *
 * These menus fetch one page and search it in the browser, so any template
 * beyond the limit is invisible to the user rather than merely unpaginated.
 * The limit is a ceiling, not a fetch size — a company with 120 templates
 * still loads 120. 200 covers the largest libraries we see today (~120) with
 * room to grow. If a company approaches it, switch the picker to the `search`
 * argument on `GET_TEXT_TEMPLATES`, which filters server-side.
 */
export const SMS_TEMPLATE_PAGE_LIMIT = 200
